function topic_weather_alarm(){
	var alert_container = {
		rain: {},
		debris: {},
		stage: {}
	};
	var alert_sum = {
		rain: {total: 0, red: 0, yellow: 0, normal: 0, grey: 0},
		debris: {total: 0, red: 0, yellow: 0, normal: 0},
		stage: {total: 0, red: 0, purple: 0, yellow: 0, normal: 0},
		jiufen: {total: 0, red: 0, normal: 0},
		flash: {total: 29, red: 0, yellow: 0, list: {} }
	};
	var rain_data = raw_data["雨量站"], rain_tbody_data = [], rain_coor_object = {};
	rain_data.forEach(function(element){
		if (element.CITY == "新北市") {
			if (alert_container.rain[element.TOWN] == undefined) {
				alert_container.rain[element.TOWN] = {red: 0, yellow: 0, normal: 0, grey: 0};
			}
			if (element.status == "大雨") {
				alert_container.rain[element.TOWN]["yellow"] += 1;
				alert_sum.rain["yellow"] += 1;
			} else if (element.status == "豪雨") {
				alert_container.rain[element.TOWN]["red"] += 1;
				alert_sum.rain["red"] += 1;
			} else if (element.status == "正常") {
				alert_container.rain[element.TOWN]["normal"] += 1;
				alert_sum.rain["normal"] += 1;
			} else {
				alert_container.rain[element.TOWN]["grey"] += 1;
				alert_sum.rain["grey"] += 1;
			}
			alert_sum.rain["total"] += 1;
			rain_tbody_data.push([element.TOWN, element.STNM, element.TIME.slice(0,16), rain_value_processing(element.MIN_10), rain_value_processing(element.RAIN), rain_value_processing(element.HOUR_24)]);
			rain_coor_object[element.STNM] = [element.LAT, element.LON];
		}
	});

	// flash & radar
	var flash_array = [], 
		radar_data = overlay_dataset["雷達強回波值"].toGeoJSON(), 
		flash_data = overlay_dataset["閃電觀測"] ? overlay_dataset["閃電觀測"].toGeoJSON() : new geoJsonTemplate(),
		radar_center_points = new geoJsonTemplate()
	radar_data.features.forEach(function(feature){
		var thisCenter = turf.center(feature)
		thisCenter.properties['value'] = feature.properties['value']
		radar_center_points.features.push(thisCenter)
	})
	var pointInRegion = {
		"radar": turf.tag(radar_center_points, overlay_dataset['Basic_map'], 'TOWNNAME', 'TOWNNAME'),
		"flash": turf.tag(flash_data, overlay_dataset['Basic_map'], 'TOWNNAME', 'TOWNNAME')
	}
	pointInRegion.radar.features.forEach(function(feature){
		var thisTown = feature.properties['TOWNNAME']
		if (thisTown != undefined) {
			if (feature.properties.value >= 40) {
				if (!alert_sum.flash.list[thisTown]) {
					alert_sum.flash.list[thisTown] = { radar: 0, flash: 0 }
				}
				alert_sum.flash.list[thisTown]['radar'] += 1
			}
		}
	})
	pointInRegion.flash.features.forEach(function(feature){
		var thisTown = feature.properties['TOWNNAME']
		if (thisTown != undefined) {
			if (!alert_sum.flash.list[thisTown]) {
				alert_sum.flash.list[thisTown] = { radar: 0, flash: 0 }
			}
			alert_sum.flash.list[thisTown]['flash'] += 1
		}
	})
	Object.keys(alert_sum.flash.list).forEach(function(eachRegion){
		var thisRegionResult = { yellow: "無發生", red: "無發生" }
		if (alert_sum.flash.list[eachRegion]['radar'] > 0) {
			alert_sum.flash.yellow += 1
			thisRegionResult.yellow = "發生(" + alert_sum.flash.list[eachRegion]['radar'] + "格)"
		}
		if (alert_sum.flash.list[eachRegion]['flash'] > 0) {
			alert_sum.flash.red += 1
			thisRegionResult.red = "發生(" + alert_sum.flash.list[eachRegion]['flash'] + "次)"
		}
		flash_array.push([eachRegion, thisRegionResult.red, thisRegionResult.yellow])
	})

	// table create
	$("#weather-cardbody").html(
		slider_card_component_create({
			"cardhead": "劇烈天氣示警統計資訊",
			"cardbody": 
				'<div class="col-6 text-center">'+
					'<h5>閃電' + alert_sum.flash.red + '區</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-red flash-red-bar" role="progressbar" aria-valuenow="' + (alert_sum.flash.red / alert_sum.flash.total)*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>強回波' + alert_sum.flash.yellow + '區</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-yellow flash-yellow-bar" role="progressbar" aria-valuenow="' + (alert_sum.flash.yellow / alert_sum.flash.total)*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-12 mb-3" id="flash_table">'+
					'<table class="table table-sm text-center" width="100%">' +
						'<thead class="thead-dark">' +
							'<tr>' +
								'<th>行政區</th>' +
								'<th>閃電</th>' +
								'<th>強回波</th>' +
							'</tr>' +
						'</thead>' +
						'<tbody class="p-cursor"></tbody>' +
					'</table>'+
				'</div>'
		}) +
		slider_card_component_create({
			"cardhead": "降雨示警統計資訊",
			"cardbody": 
				'<div class="col-6 text-center">'+
					'<h5>豪雨' + alert_sum.rain["red"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-red rain-red-bar" role="progressbar" aria-valuenow="' + (alert_sum.rain["red"]/alert_sum.rain["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>大雨' + alert_sum.rain["yellow"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-yellow rain-yellow-bar" role="progressbar" aria-valuenow="' + (alert_sum.rain["yellow"]/alert_sum.rain["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>未達' + alert_sum.rain["normal"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-green rain-normal-bar" role="progressbar" aria-valuenow="' + (alert_sum.rain["normal"]/alert_sum.rain["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div class="col-6 text-center">'+
					'<h5>異常' + alert_sum.rain["grey"] + '處</h5>'+
					'<div class="progress mb-2 mt-2">'+
						'<div class="progress-bar bg-alert-grey rain-grey-bar" role="progressbar" aria-valuenow="' + (alert_sum.rain["grey"]/alert_sum.rain["total"])*100 + '" aria-valuemin="0" aria-valuemax="100"></div>'+
					'</div>'+
				'</div>'+
				'<div id="rain_sta" class="col-12 h-280"></div>'+
				'<div class="col-12 mb-3" id="rain_table">'+
					'<table class="table table-sm text-center" width="100%">' +
						'<thead class="thead-dark">' +
							'<tr>' +
								'<th rowspan="2">行政區</th>' +
								'<th rowspan="2">站名</th>' +
								'<th rowspan="2">時間</th>' +
								'<th class="text-center" colspan="3">觀測雨量</th>' +
							'</tr>' +
							'<tr>' +
								'<th>10分鐘</th>' +
								'<th>1小時</th>' +
								'<th>24小時</th>' +
							'</tr>' +
						'</thead>' +
						'<tbody class="p-cursor"></tbody>' +
					'</table>'+
				'</div>'
		})
	);

	for (var category in alert_sum) {
		for (var level in alert_sum[category]) {
			$("." + category + "-" + level + "-bar").css("width", (alert_sum[category][level] / alert_sum[category]["total"])*100 + "%")	
		}
	}

    $('#flash_table table').DataTable({
        "data": flash_array,
        "deferRender": true,
        "order": [[ 1, "desc" ]],
        "searching": true
    }).on('click', 'tbody tr', function(){
		zoomToRegionMap($(this).find('td').eq(0).html())
	})

    $('#rain_table table').DataTable({
        "data": rain_tbody_data,
        "deferRender": true,
        "order": [[ 3, "desc" ]],
        "searching": true
    });

    $("#rain_table tbody").on("click", "tr", function(){
        var coor_array = rain_coor_object[$(this).find("td").eq(1).html()];
        map.setView(coor_array, 18);
    });

	stacked_percent_chart({
		div: "rain_sta",
		data: alert_container.rain,
		key_name: ["red", "yellow", "normal", "grey"],
		label: ["豪雨", "大雨", "未達", "異常"],
		color: ['#e85a71', '#FFBC42', '#3ac569', '#ced4da']
	});
}